import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, input, output } from '@angular/core';
import { RouterModule } from '@angular/router';

import { NavItem } from '../../interfaces/nav-item';
import { MenuListItemComponent } from '../../molecules/menu-list-item/menu-list-item.component';

@Component({
  selector: 'locumsnest-side-nav-bar',
  templateUrl: './side-nav-bar.component.html',
  styleUrls: ['./side-nav-bar.component.scss'],
  imports: [MenuListItemComponent, RouterModule],
  animations: [
    trigger('slideInOut', [
      state('true', style({ overflow: 'hidden', width: '175px', height: '100%' })),
      state('false', style({ width: '60px', height: '100%' })),
      transition('false <=> true', animate('100ms ease-in-out')),
    ]),
  ],
})
export class SideNavBarComponent {
  idx = input<string>();
  itemList = input<NavItem[]>([]);
  filtersPanelExpanded = input<boolean>();
  nestPanelExpanded = input<boolean>();
  filterCount = input<number>();
  activeNavItem = input<string | null>();
  filtersDisabled = input<boolean>();
  hospitalOfficerPath = input<string>();
  isAgencyPlatform = input<boolean>();
  showMessagingPanel = input<boolean>();
  hasUnreadMessages = input<boolean>(true);

  toggled = output<void>();
  clicked = output<void>();
  expanded = output<boolean>();
  filterMenuClicked = output<void>();
  messagingMenuClicked = output<void>();

  public menuExpanded = false;

  onToggle(event) {
    this.toggled.emit(event);
  }

  onMenuExpanded() {
    this.menuExpanded = !this.menuExpanded;
    this.expanded.emit(this.menuExpanded);
  }

  onFilterMenuClicked() {
    this.filterMenuClicked.emit();
  }

  onMessagingMenuClicked() {
    this.messagingMenuClicked.emit();
  }

  onClick(event) {
    this.clicked.emit(event);
  }
}
